module.exports = __webpack_public_path__ + "static/media/Prev-wo-background.c8d8922c.svg";